var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack205({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.2,10.31l1.64-.17a1.35,1.35,0,0,0,.41.88,1.13,1.13,0,0,0,.8.33,1.11,1.11,0,0,0,.87-.42,1.89,1.89,0,0,0,.36-1.26,1.78,1.78,0,0,0-.35-1.19A1.21,1.21,0,0,0,8,8.09a1.7,1.7,0,0,0-1.27.62L5.4,8.52l.84-4.47h4.35V5.59H7.49L7.23,7.05a2.54,2.54,0,0,1,1.12-.28,2.49,2.49,0,0,1,1.86.8A2.86,2.86,0,0,1,11,9.64a3.07,3.07,0,0,1-.61,1.89A2.74,2.74,0,0,1,8,12.67,2.87,2.87,0,0,1,6.09,12,2.6,2.6,0,0,1,5.2,10.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack205);
export default __webpack_public_path__ + "static/media/Symbolpack_2_05.a401978f3e6a27a171c5705f3f7f23db.svg";
export { ForwardRef as ReactComponent };